import React from 'react';

// GlowyAI sohbetinde backend'den gelen hazir tablo (hucreler zaten TR bicimli string).
// table: { id, title, columns:[{label, align}], rows:[[string]], note? }
export default function GlowyDataTable({ table }) {
  if (!table || !Array.isArray(table.columns) || !Array.isArray(table.rows)) return null;
  const cols = table.columns;
  const alignCls = (c) => (c && c.align === 'right' ? 'text-right' : 'text-left');
  return (
    <div className="my-2 first:mt-0 glowy-data-table">
      {table.title && <div className="text-xs font-semibold text-gray-700 mb-1">{table.title}</div>}
      <div className="overflow-x-auto rounded-lg border border-gray-200 bg-white">
        <table className="min-w-full border-collapse text-xs text-gray-800">
          <thead className="bg-gray-50">
            <tr>
              {cols.map((c, ci) => (
                <th key={ci} className={`px-2.5 py-1.5 font-semibold text-gray-600 whitespace-nowrap border-b border-gray-200 ${alignCls(c)}`}>{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((r, ri) => (
              <tr key={ri} className="border-b border-gray-100 last:border-b-0">
                {cols.map((c, ci) => (
                  <td key={ci} className={`px-2.5 py-1.5 ${alignCls(c)} ${c && c.align === 'right' ? 'tabular-nums whitespace-nowrap' : ''}`}>{r && r[ci] != null ? String(r[ci]) : ''}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {table.note && <div className="text-[11px] text-gray-500 mt-1">{table.note}</div>}
    </div>
  );
}
